export default {
  issuerAffiliatesList: [],
  activeIssuerAffiliate: {},
};
